module.exports = __webpack_public_path__ + "static/media/card.ea8b2441.png";